import ObjectVisitorSegmentApiModel from './ObjectVisitorSegmentApiModel.js'

export default class ResourceSegmentApiModel {
  constructor(rawModel) {
    this.ResourceKey = rawModel?.ResourceKey || null
    this.Segments = rawModel?.Segments?.map(x => new ObjectVisitorSegmentApiModel(x)) || null
    this.SegmentlessResource = rawModel?.SegmentlessResource || null
  }
}
